<div class="listAndCreateContainer">
	<ul class="fa-ul">
		@for (element of elements; track trackByStringValue(i, element); let i = $index) {
			<li>
				<span class="fa-li">
					<i
						class="{{
							(fontAwesomeCodeFunction?.(element)?.fontSet ?? fontAwesomeCode.fontSet) +
								' ' +
								(fontAwesomeCodeFunction?.(element)?.fontIcon ?? fontAwesomeCode.fontIcon)
						}}"
					></i>
				</span>
				<div class="liCon">
					@if (!inlineEditOfItems) {
						<p class="dottedField">
							{{ getElementViewValue(element) }}
						</p>
					}
					@if (inlineEditOfItems) {
						<div class="editableItem">
							<sim-admin-settings-input-to-label-transformer
								[type]="'text'"
								[showCopyBtn]="false"
								[inEditMode]="inEditMode"
								(valueHasChanged)="
									valueChangedForElementEmitter.emit({
										value: $event,
										index: i,
									})
								"
								[value]="element"
							/>
						</div>
					}
					@if (inEditMode && hasDeleteButton) {
						<button mat-icon-button color="warn" (click)="onDeleteItemClicked.emit(i)" [@zoomInOnEnter] [@zoomOutOnLeave]>
							<mat-icon fontSet="fad" fontIcon="fa-trash-alt" />
						</button>
					}
				</div>
			</li>
		}
	</ul>

	@if (showNoItems && elements?.length <= 0) {
		<div class="noItems">
			{{ noItemsText | translate }}
		</div>
	}

	@if (inEditMode && hasCreateButton) {
		<button [@zoomInOnEnter] (click)="onAddItemClicked.emit()" class="createButton" mat-button color="accent" appStopPropagation>
			<i class="fad fa-edit"></i>{{ T.SHARED_EDITABLE_LIST_EDIT_ITEM | translate }}
		</button>
	}
</div>
